
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityEtapasEmpresaService } from './entity-etapas-empresa.service';
import {
  EntityEtapasEmpresaAddFailure,
  EntityEtapasEmpresaAddRequest,
  EntityEtapasEmpresaAddSuccess,
  EntityEtapasEmpresaDeleteFailure,
  EntityEtapasEmpresaDeleteRequest,
  EntityEtapasEmpresaDeleteSuccess,
  EntityEtapasEmpresaLoadFailure,
  EntityEtapasEmpresaLoadRequest,
  EntityEtapasEmpresaLoadSuccess,
  EntityEtapasEmpresaUpdateFailure,
  EntityEtapasEmpresaUpdateRequest,
  EntityEtapasEmpresaUpdateSuccess
} from './entity-etapas-empresa.actions';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class EntityEtapasEmpresaEffects {
  constructor(
    private actions$: Actions,
    private EntityEtapasEmpresaService: EntityEtapasEmpresaService,
    private notificationService: NotificationService
  ) {}

  loadRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEtapasEmpresaLoadRequest),
      mergeMap(() =>
        this.EntityEtapasEmpresaService.getAll().pipe(
          map((items) => EntityEtapasEmpresaLoadSuccess({ items })),
          catchError((error) => of(EntityEtapasEmpresaLoadFailure({ error })))
        )
      )
    )
  );

  addRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEtapasEmpresaAddRequest),
      mergeMap((action) =>
        this.EntityEtapasEmpresaService.add(action.item).pipe(
          map((item) => EntityEtapasEmpresaAddSuccess({ item })),
          catchError((error) => of(EntityEtapasEmpresaAddFailure({ error })))
        )
      )
    )
  );

  updateRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEtapasEmpresaUpdateRequest),
      mergeMap((action) =>
        this.EntityEtapasEmpresaService.update(action.item).pipe(
          map((item) => EntityEtapasEmpresaUpdateSuccess({ item: action.item })),
          catchError((error) => of(EntityEtapasEmpresaUpdateFailure({ error })))
        )
      )
    )
  );

  deleteRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEtapasEmpresaDeleteRequest),
      mergeMap((action) =>
        this.EntityEtapasEmpresaService.delete(action.item).pipe(
          map((item) => {
            this.notificationService.success(
              'EntityEtapasEmpresa eliminado correctamente.'
            );
            return EntityEtapasEmpresaDeleteSuccess({ item: action.item });
          }),
          catchError((error) => of(EntityEtapasEmpresaDeleteFailure({ error })))
        )
      )
    )
  );

  addSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEtapasEmpresaAddSuccess),
        tap(() =>
          this.notificationService.success(
            'EntityEtapasEmpresa registrado correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  addFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEtapasEmpresaAddFailure),
        tap(() =>
          this.notificationService.error('Error al registrar EntityEtapasEmpresa.')
        )
      ),
    { dispatch: false }
  );

  updateSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEtapasEmpresaUpdateSuccess),
        tap(() =>
          this.notificationService.success(
            'EntityEtapasEmpresa actualizado correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  updateFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEtapasEmpresaUpdateFailure),
        tap(() =>
          this.notificationService.error('Error al actualizar EntityEtapasEmpresa.')
        )
      ),
    { dispatch: false }
  );

  deleteSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEtapasEmpresaDeleteSuccess),
        tap(() =>
          this.notificationService.success(
            'EntityEtapasEmpresa eliminado correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  deleteFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEtapasEmpresaDeleteFailure),
        tap(() =>
          this.notificationService.error('Error al eliminar EntityEtapasEmpresa.')
        )
      ),
    { dispatch: false }
  );
}
